import {
  Menu,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import { MdPeople, MdVisibility, MdVisibilityOff } from "react-icons/md";

import { IconButton, MenuButton } from "../../../components";
import { CallNoteVisibility } from "../../graphql";

interface VisibilityMenuProps {
  visibility: CallNoteVisibility;
  onChange: (visibility: CallNoteVisibility) => void;
}

const VisibilityMenu = React.forwardRef<HTMLDivElement, VisibilityMenuProps>(
  ({ visibility, onChange }, _ref) => {
    return (
      <Menu
        placement="left-start"
        computePositionOnMount
        strategy="fixed"
        autoSelect={false}
      >
        <Tooltip label="Visibility">
          <MenuButton
            as={IconButton}
            aria-label="visibility-menu"
            icon={
              visibility === CallNoteVisibility.Public ? (
                <MdVisibility />
              ) : visibility === CallNoteVisibility.CallOwner ? (
                <MdPeople />
              ) : (
                <MdVisibilityOff />
              )
            }
            data-testid="call-note-visibility"
            color="textNote"
            _hover={{ bg: "surfaceMenuHover" }}
            _active={{ bg: "surfaceMenuActive" }}
          />
        </Tooltip>
        <MenuList bg="surfaceMenu" borderColor="borderSubtle" borderWidth="1px">
          <MenuOptionGroup
            value={visibility}
            title="Visibility"
            type="radio"
            onChange={(value) => onChange(value as CallNoteVisibility)}
          >
            <MenuItemOption
              value={CallNoteVisibility.Public}
              data-testid="visibility-public"
              _hover={{ bg: "surfaceMenuHover" }}
              _focus={{ bg: "surfaceMenuHover" }}
            >
              Hiring team
            </MenuItemOption>
            <MenuItemOption
              value={CallNoteVisibility.CallOwner}
              data-testid="visibility-callowner"
              _hover={{ bg: "surfaceMenuHover" }}
              _focus={{ bg: "surfaceMenuHover" }}
            >
              Interviewers
            </MenuItemOption>
            <MenuItemOption
              value={CallNoteVisibility.Private}
              data-testid="visibility-private"
              _hover={{ bg: "surfaceMenuHover" }}
              _focus={{ bg: "surfaceMenuHover" }}
            >
              Only you
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    );
  }
);

export default VisibilityMenu;
